import { ThemeEvents, CartUpdateEvent } from '@theme/events';
import { debounce, fetchConfig } from '@theme/utilities';

let d2cFreeGiftPruning = false;

/**
 * Removes D2C free gift lines when their parent (main PDP) variant is no longer in the cart.
 * Gift lines are tagged with properties _d2c_free_gift / _d2c_parent_variant at add time.
 */
async function pruneOrphanD2cFreeGifts() {
  if (d2cFreeGiftPruning) return;
  d2cFreeGiftPruning = true;
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const items = /** @type {any[]} */ (cart.items);
    if (!items?.length) return;

    const variantIdsInCart = new Set(items.map((/** @type {{ variant_id: number }} */ i) => i.variant_id));

    const orphans = items.filter((item) => {
      const p = item.properties;
      if (!p || p._d2c_free_gift !== '1' || !p._d2c_parent_variant) return false;
      const parentId = parseInt(String(p._d2c_parent_variant), 10);
      return Number.isFinite(parentId) && !variantIdsInCart.has(parentId);
    });

    if (orphans.length === 0) return;

    /** @type {Record<string, number>} */
    const updates = {};
    for (const item of orphans) {
      if (item.key) updates[item.key] = 0;
    }

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = /** @type {string[]} */ ([]);
    cartItemsComponents.forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    const body = JSON.stringify({
      updates,
      sections: sectionIds.join(','),
      sections_url: window.location.pathname,
    });

    const ch = await fetch(Theme.routes.cart_update_url, fetchConfig('json', { body }));
    const text = await ch.text();
    const data = JSON.parse(text);

    const newCount = typeof data.item_count === 'number' ? data.item_count : undefined;
    document.dispatchEvent(
      new CartUpdateEvent(data, 'd2c-free-gift-prune', {
        itemCount: newCount ?? 0,
        source: 'd2c-free-gift-cart',
        sections: data.sections,
      })
    );
  } catch (e) {
    console.error('[d2c-free-gift-cart]', e);
  } finally {
    d2cFreeGiftPruning = false;
  }
}

const debouncedPrune = debounce(() => {
  void pruneOrphanD2cFreeGifts();
}, 0);

/**
 * @param {Event} e
 */
function onCartUpdateForPrune(e) {
  const source = /** @type {CustomEvent} */ (e).detail?.data?.source;
  if (source === 'd2c-free-gift-cart' || source === 'd2c-free-gift-prune') return;
  debouncedPrune();
}

document.addEventListener(ThemeEvents.cartUpdate, onCartUpdateForPrune);
